import React from "react";
import {
  makeStyles,
  Grid,
  IconButton,
  MenuItem,
  createStyles,
  Theme,
  withStyles,
  Divider,
  Typography,
} from "@material-ui/core";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Menu, { MenuProps } from "@material-ui/core/Menu";
import { ProModal } from "./ProModal";
import { IUser } from "../core/redux/dataMap/user";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import SettingsIcon from "@material-ui/icons/Settings";
import { ReactComponent as CheckIcon } from "../assets/imgs/icons/check.svg";
import { useHistory } from "react-router-dom";
import { Profile } from "../containers/user/Profile";
import { CustomAvatar } from "./CustomAvatar";
import { FeedbackModal } from "../containers/user/FeedbackModal";
import useLanguage from "../hooks/useLanguage";

interface IUserActionsProps {
  user: IUser;
  userHasAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UserActions: React.FC<IUserActionsProps> = ({
  user,
  userHasAuthenticated,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowFeedback, setModalShowFeedback] = React.useState(false);
  const [isOpenProfileModal, showProfileModal] = React.useState(false);
  const { language } = useLanguage();
  const { translate } = language;
  const history = useHistory();

  const open = Boolean(anchorEl);
  // const isPremium = user ? user.isPremium : false;
  const classes = useStyles();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFeedback = () => {
    setModalShowFeedback(true);
  };

  function handleLogout() {
    setAnchorEl(null);
    userHasAuthenticated(false);
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
  }

  function handleUserClick(type) {
    handleClose();
    showProfileModal(true);
  }

  function handleSource(type) {
    history.push({
      pathname: "/sources",
    });
  }

  return (
    <div className={classes.root}>
      <IconButton
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="primary"
      >
        <CustomAvatar size="sm" user={user} />
      </IconButton>

      <StyledMenu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        <div className={classes.header}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item md={3}>
              <CustomAvatar size="sm" user={user} />
            </Grid>
            <Grid item md={9}>
              <Typography variant="subtitle1">{` ${user?.firstName} ${user?.lastName}`}</Typography>
            </Grid>
          </Grid>
        </div>
        {/* {!!isPremium && (
          <StyledMenuItem onClick={() => handleProModal("Folder")}>
            <EmojiPeopleIcon />
            Melde dich für Pro an!
          </StyledMenuItem>
        )} */}
        <Divider />
        <StyledMenuItem onClick={handleUserClick}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item md={3}>
              <SettingsIcon />
            </Grid>
            <Grid item md={9}>
              {translate.user_header}
            </Grid>
          </Grid>
        </StyledMenuItem>
        <Divider />
        <StyledMenuItem onClick={handleSource}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item md={3}>
              <CheckIcon style={{ width: 25, height: 25 }} />
            </Grid>
            <Grid item md={9}>
              {translate.sources}
            </Grid>
          </Grid>
        </StyledMenuItem>
        <Divider />
        <StyledMenuItem onClick={handleFeedback}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item md={3}>
              <FavoriteBorderIcon color="error" />
            </Grid>
            <Grid item md={9}>
              {translate.feedback}
            </Grid>
          </Grid>
        </StyledMenuItem>
        <Divider />
        <StyledMenuItem onClick={handleLogout}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item md={3}>
              <ExitToApp />
            </Grid>
            <Grid item md={9}>
              {translate.logout}
            </Grid>
          </Grid>
        </StyledMenuItem>
      </StyledMenu>
      <Profile
        isOpen={isOpenProfileModal}
        closeModal={() => showProfileModal(false)}
        user={user}
      />
      <ProModal isOpen={modalShow} closeModal={() => setModalShow(false)} />
      <FeedbackModal
        isOpen={modalShowFeedback}
        closeModal={() => setModalShowFeedback(false)}
      />
    </div>
  );
};

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
    width: "250px",
    // height: "272px",
    padding: "0 10px",
    boxShadow: "2px 2px 20px rgba(0, 0, 0, 0.25)",
  },
})((props: MenuProps) => <Menu elevation={0} {...props} />);

const StyledMenuItem = withStyles((theme) => ({
  root: {
    height: "50px",
    paddign: 0,
    "&:active": {
      outline: "none",
    },
    "&:hover": {
      outline: "none",
    },
    "&.Mui-selected": {
      outline: "none",
    },
  },
}))(MenuItem);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    header: {
      padding: "10px 0",
      outline: "none",
      "&:hover": {
        outline: "none",
      },
      "&:active": {
        outline: "none",
      },
      "&.Mui-selected": {
        outline: "none",
      },
    },
    menu: {
      "&:active": {
        outline: "none",
      },
      "&:hover": {
        outline: "none",
      },
      "&.Mui-selected": {
        outline: "none",
      },
    },
  })
);
